import React, { Component } from 'react';
import Footer from '../components/footer';

export default class Insurance extends Component {

    componentDidMount() {
        document.title = this.props.texts["insuranceAndServicesTitle"]
    }

    render() {
        return (
            <div className="category-main-body">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 p-3 insurance">
                        <h1>{this.props.texts["insurance"]}</h1>
                        <p className="mb-5">{this.props.texts["insuranceText"]}</p>
                        {/* <div className="w-100 text-center">
                            <button >
                                button
                            </button>
                        </div> */}
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 p-3 service">
                        <h1>{this.props.texts["services"]}</h1>
                        <p className="mb-5">{this.props.texts["servicesText"]}</p>
                        {/* <div className="w-100 text-center">
                            <button >
                                button
                            </button>
                        </div> */}
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}